import React from 'react'
import { useTranslation } from 'react-i18next'
import { TaskOptionsProps } from './TaskOptions.types'
import './TaskOptions.scss'

const OptionsIcon: React.FC = () => (
  <svg width="12" height="3" viewBox="0 0 12 3" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1.35C0 1.16 0.04 0.99 0.11 0.83C0.18 0.66 0.28 0.52 0.4 0.41C0.52 0.28 0.66 0.18 0.83 0.11C0.99 0.04 1.16 0 1.35 0C1.54 0 1.71 0.04 1.87 0.11C2.04 0.18 2.18 0.28 2.29 0.41C2.42 0.52 2.52 0.66 2.59 0.83C2.66 0.99 2.7 1.16 2.7 1.35C2.7 1.54 2.66 1.71 2.59 1.87C2.52 2.04 2.42 2.18 2.29 2.3C2.18 2.42 2.04 2.52 1.87 2.59C1.71 2.66 1.54 2.7 1.35 2.7C1.16 2.7 0.99 2.66 0.83 2.59C0.66 2.52 0.52 2.42 0.4 2.3C0.28 2.18 0.18 2.04 0.11 1.87C0.04 1.71 0 1.54 0 1.35Z" fill="currentColor"/>
    <path d="M4.6 1.35C4.6 1.16 4.64 0.99 4.71 0.83C4.78 0.66 4.88 0.52 5 0.41C5.12 0.28 5.26 0.18 5.43 0.11C5.59 0.04 5.76 0 5.95 0C6.14 0 6.31 0.04 6.47 0.11C6.64 0.18 6.78 0.28 6.89 0.41C7.02 0.52 7.12 0.66 7.19 0.83C7.26 0.99 7.3 1.16 7.3 1.35C7.3 1.54 7.26 1.71 7.19 1.87C7.12 2.04 7.02 2.18 6.89 2.3C6.78 2.42 6.64 2.52 6.47 2.59C6.31 2.66 6.14 2.7 5.95 2.7C5.76 2.7 5.59 2.66 5.43 2.59C5.26 2.52 5.12 2.42 5 2.3C4.88 2.18 4.78 2.04 4.71 1.87C4.64 1.71 4.6 1.54 4.6 1.35Z" fill="currentColor"/>
    <path d="M9.2 1.35C9.2 1.16 9.24 0.99 9.31 0.83C9.38 0.66 9.48 0.52 9.6 0.41C9.72 0.28 9.86 0.18 10.03 0.11C10.19 0.04 10.36 0 10.55 0C10.73 0 10.91 0.04 11.07 0.11C11.24 0.18 11.38 0.28 11.49 0.41C11.62 0.52 11.72 0.66 11.79 0.83C11.86 0.99 11.9 1.16 11.9 1.35C11.9 1.54 11.86 1.71 11.79 1.87C11.72 2.04 11.62 2.18 11.49 2.3C11.38 2.42 11.24 2.52 11.07 2.59C10.91 2.66 10.73 2.7 10.55 2.7C10.36 2.7 10.19 2.66 10.03 2.59C9.86 2.52 9.72 2.42 9.6 2.3C9.48 2.18 9.38 2.04 9.31 1.87C9.24 1.71 9.2 1.54 9.2 1.35Z" fill="currentColor"/>
  </svg>
)

export const TaskOptions: React.FC<TaskOptionsProps> = ({
  variant = 'standard',
  onClick,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <button
      className={`task-options task-options--${variant}${className ? ` ${className}` : ''}`}
      type="button"
      title={t('taskCreation.actionOptions')}
      onClick={onClick}
    >
      <OptionsIcon />
    </button>
  )
}
